export { ReactComponent as NonActiveDashIcon } from "../assets/n-dashboard.svg";
export { ReactComponent as ActiveDashIcon } from "../assets/a-dashboard.svg";
export { ReactComponent as NonActiveRealIcon } from "../assets/n-real-estate.svg";
export { ReactComponent as ActiveRealIcon } from "../assets/a-real-estate.svg";
export { ReactComponent as NonActiveCardIcon } from "../assets/n-card-travel.svg";
export { ReactComponent as ActiveCardIcon } from "../assets/a-card-travel.svg";
export { ReactComponent as BellIcon } from "../assets/bell-icon.svg";
export { ReactComponent as ExchangeOneIcon } from "../assets/exchange-one-icon.svg";
export { ReactComponent as ExchangeOneTwo } from "../assets/exchange-two-icon.svg";
export { ReactComponent as ExchangeOneThree } from "../assets/exchange-three-icon.svg";
export { ReactComponent as RiskAppetiteIcon } from "../assets/risk-appetite-icon.svg";
export { ReactComponent as SavingsIcon } from "../assets/savings-icon.svg";
export { ReactComponent as SavingsIconTwo } from "../assets/savings-icon-two.svg";
export { ReactComponent as IsValidIcon } from "../assets/is-valid-icon.svg";
export { ReactComponent as PigIcon } from "../assets/pig-icon.svg";
export { ReactComponent as SavingChartIcon } from "../assets/saving-chart-icon.svg";
export { ReactComponent as SavingKeyIcon } from "../assets/saving-key-icon.svg";
export { ReactComponent as EmptyIcon } from "../assets/empty-icon.svg";
export { ReactComponent as QuestionMarkIcon } from "../assets/question-icon.svg";
export { ReactComponent as SuccessCheckIcon } from "../assets/check-icon.svg";
export { ReactComponent as InfoIcon } from "../assets/marketform-info-icon.svg";
export { ReactComponent as InfoPop } from "../assets/infopop.svg";
export { ReactComponent as ErrorIcon } from "../assets/erroricon.svg";
export { ReactComponent as SearchIcon } from "../assets/search-icon.svg";
export { ReactComponent as FilterIcon } from "../assets/filter-icon.svg";
export { ReactComponent as NoDataIcon } from "../assets/empty.svg";
export { ReactComponent as ExclamationIcon } from "../assets/exclamation-icon.svg";
export { ReactComponent as BankIcon } from "../assets/bank-icon.svg";
export { ReactComponent as CardIcon } from "../assets/card-icon.svg";
export { ReactComponent as CheckIcon } from "../assets/check.svg";
export { ReactComponent as PendingIcon } from "../assets/pending-icon.svg";
export { ReactComponent as BoxImage } from "../assets/boxImage.svg";
export { ReactComponent as PersonalImage } from "../assets/personalImage.svg";
export { ReactComponent as BusinessImage } from "../assets/businessImage.svg";
export { ReactComponent as CircledPlaneIcon } from "../assets/circled-plane.svg";
export { ReactComponent as CircledSellIcon } from "../assets/circled-sell-card.svg";
export { ReactComponent as CircledFinanceIcon } from "../assets/circled-finance.svg";
export { ReactComponent as InactiveWalletIcon } from "../assets/inactive-wallet-icon.svg";
